import { useEffect, useState } from 'react';
import { AlertTriangle, Trash2 } from 'lucide-react';

/* ─── API pública — usar en cualquier archivo ─────────────────────
   import { showConfirm } from '@/components/ui/GlobalConfirm';

   if (!(await showConfirm('¿Eliminar este cliente?'))) return;

   // Con opciones:
   const ok = await showConfirm('¿Eliminar TODO?', {
     titulo: 'Eliminar organización',
     confirmText: 'Eliminar',
     peligro: true,            // estilo rojo (default true)
   });
──────────────────────────────────────────────────────────────────── */
const EVENT = 'lexorbit:confirm';

export function showConfirm(message, opts = {}) {
  return new Promise((resolve) => {
    window.dispatchEvent(new CustomEvent(EVENT, { detail: { message, opts, resolve } }));
  });
}

export default function GlobalConfirm() {
  const [actual, setActual] = useState(null);

  useEffect(() => {
    const handler = (e) => setActual(e.detail);
    window.addEventListener(EVENT, handler);
    return () => window.removeEventListener(EVENT, handler);
  }, []);

  if (!actual) return null;

  const { message, opts, resolve } = actual;
  const {
    titulo = 'Confirmar acción',
    confirmText = 'Eliminar',
    cancelText = 'Cancelar',
    peligro = true,
  } = opts || {};

  const cerrar = (valor) => { setActual(null); resolve(valor); };

  const Icono = peligro ? Trash2 : AlertTriangle;
  const colorIcono = peligro ? 'text-red-400' : 'text-[#C9A44C]';
  const fondoIcono = peligro ? 'bg-red-500/15' : 'bg-[#C9A44C]/15';
  const btnConfirm = peligro
    ? 'bg-red-500/20 text-red-400 border-red-500/30 hover:bg-red-500/30'
    : 'bg-[#C9A44C]/20 text-[#C9A44C] border-[#C9A44C]/30 hover:bg-[#C9A44C]/30';

  return (
    <div className="fixed inset-0 z-[9998] flex items-center justify-center p-4 bg-black/70 backdrop-blur-sm"
      style={{ fontFamily: 'Outfit, sans-serif' }}
      onClick={(e) => { if (e.target === e.currentTarget) cerrar(false); }}>
      <div className="w-full max-w-sm bg-[#0E0E0E] border border-[rgba(201,164,76,0.2)] rounded-2xl p-6 shadow-2xl">
        <div className="flex items-center gap-3 mb-3">
          <div className={`w-10 h-10 rounded-full ${fondoIcono} flex items-center justify-center flex-shrink-0`}>
            <Icono className={`w-5 h-5 ${colorIcono}`} />
          </div>
          <h3 className="text-lg text-[#F8F6F0]" style={{ fontFamily: 'Playfair Display, serif' }}>{titulo}</h3>
        </div>
        <p className="text-[#B8B8B8] text-sm leading-relaxed mb-5">{message}</p>
        <div className="flex gap-3 justify-end">
          <button onClick={() => cerrar(false)}
            className="px-4 py-2.5 text-sm text-[#B8B8B8] hover:text-[#F8F6F0] transition-colors">
            {cancelText}
          </button>
          <button onClick={() => cerrar(true)} autoFocus
            className={`px-4 py-2.5 text-sm rounded-lg border transition-colors flex items-center gap-2 ${btnConfirm}`}>
            <Icono className="w-4 h-4" />
            {confirmText}
          </button>
        </div>
      </div>
    </div>
  );
}
